import { RelatorioServicosVeicularesModel } from '@/models/administracao/servicos-veiculares/RelatorioServicosVeicularesModel';
import { integracaoContabilApi } from '@/api/IntegracaoContabilApi';

export default class GerencialServicosVeicularesService {

    static gerarRelatorio(tipo: string, request: RelatorioServicosVeicularesModel) {
        return integracaoContabilApi.gerarRelatorioServicosVeiculares(tipo, request);
    }

    static dadosRelatorioServicosVeiculares(request: RelatorioServicosVeicularesModel) {
        return integracaoContabilApi.dadosRelatorioServicosVeiculares(request);
    }
    
}